import { Fragment } from "react";
import { Dialog, Transition } from "@headlessui/react";
import { EyeDropperIcon, EyeIcon, InformationCircleIcon, XMarkIcon } from "@heroicons/react/24/outline";
import { PlusCircleIcon } from "@heroicons/react/24/outline";
import { XCircleIcon } from "@heroicons/react/24/outline";

export default function SlideOver({ Title, open, setOpen, chilren }) {
  return (
    <Transition.Root show={open} as={Fragment}>
      <Dialog as="div" className="relative z-50" onClose={setOpen}>
        <Transition.Child
          as={Fragment}
          enter="ease-in-out duration-500"
          enterFrom="opacity-0"
          enterTo="opacity-100"
          leave="ease-in-out duration-500"
          leaveFrom="opacity-100"
          leaveTo="opacity-0"
        >
          <div className="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity" />
        </Transition.Child>

        <div className="fixed inset-0 overflow-hidden">
          <div className="absolute inset-0 overflow-hidden">
            <div className="pointer-events-none fixed inset-y-0 right-0 flex max-w-full pl-10">
              <Transition.Child
                as={Fragment}
                enter="transform transition ease-in-out duration-500 sm:duration-700"
                enterFrom="translate-x-full"
                enterTo="translate-x-0"
                leave="transform transition ease-in-out duration-500 sm:duration-700"
                leaveFrom="translate-x-0"
                leaveTo="translate-x-full"
              >
                <Dialog.Panel className="pointer-events-auto relative w-screen max-w-md">
                  <Transition.Child
                    as={Fragment}
                    enter="ease-in-out duration-500"
                    enterFrom="opacity-0"
                    enterTo="opacity-100"
                    leave="ease-in-out duration-500"
                    leaveFrom="opacity-100"
                    leaveTo="opacity-0"
                  >
                    <div className="absolute top-0 left-0 -ml-8 flex pt-4 pr-2 sm:-ml-10 sm:pr-4">
                      <button
                        type="button"
                        className="rounded-md text-gray-300 hover:text-white focus:outline-none focus:ring-2 focus:ring-white"
                        onClick={() => setOpen(false)}
                      >
                        <span className="sr-only">Close panel</span>
                        <XCircleIcon className="h-6 w-6 text-red-500" aria-hidden="true" />
                      </button>
                    </div>
                  </Transition.Child>
                  <div className="flex h-full flex-col overflow-y-scroll bg-white py-6 shadow-xl dark:bg-gray-800">
                    <div className="px-4 sm:px-6">
                      <Dialog.Title className="text-xl font-semibold font-bg-indigo-50 px-6 py-2 rounded-md text-indigo-500  border border-transparent dark:text-orange-400">
                        <InformationCircleIcon className="w-6 h-6 inline" /> {Title}
                      </Dialog.Title>
                    </div>
                    <hr className="text-gray-300 dark:text-gray-700 mx-1" />
                    <div className="relative mt-6 flex-1 px-4 sm:px-6">
                      {/* Replace with your content */}

                      <div className="absolute inset-0 px-4 sm:px-6 ">
                        {/* <!-- component --> */}
                        <div className="">
                          {/* <!-- Author: FormBold Team --> */}
                          {/* <!-- Learn More: https://formbold.com --> */}
                          <div className="mx-auto w-full max-w-[550px] bg-white dark:bg-gray-800">
                            <form
                              className="py-6 px-1"
                              action="https://formbold.com/s/FORM_ID"
                              method="POST"
                            >
                              <div className="mb-5">
                                <label
                                  htmlFor="email"
                                  className="mb-2 block text-base font-medium text-[#07074D] dark:text-gray-300"
                                >
                                  Item:
                                </label>
                                <input
                                  type="text"
                                  name="email"
                                  id="email"
                                  placeholder="Item name"
                                  className="w-full rounded-md border border-[#e0e0e0] bg-white py-2 px-6 text-base font-medium text-gray-700 outline-none focus:border-orange-500 focus:shadow-md dark:bg-gray-700 dark:text-gray-300"
                                />
                              </div>
                              <div className="mb-5">
                                <label
                                  htmlFor="email"
                                  className="mb-2 block text-base font-medium text-[#07074D] dark:text-gray-300"
                                >
                                  Item:
                                </label>
                                <input
                                  type="text"
                                  name="email"
                                  id="email"
                                  placeholder="Item name"
                                  className="w-full rounded-md border border-[#e0e0e0] bg-white py-2 px-6 text-base font-medium text-gray-700 outline-none focus:border-orange-500 focus:shadow-md dark:bg-gray-700 dark:text-gray-300"
                                />
                              </div>
                              <div className="mb-5">
                                <label
                                  htmlFor="email"
                                  className="mb-2 block text-base font-medium text-[#07074D] dark:text-gray-300"
                                >
                                  Item:
                                </label>
                                <input
                                  type="text"
                                  name="email"
                                  id="email"
                                  placeholder="Item name"
                                  className="w-full rounded-md border border-[#e0e0e0] bg-white py-2 px-6 text-base font-medium text-gray-700 outline-none focus:border-orange-500 focus:shadow-md dark:bg-gray-700 dark:text-gray-300"
                                />
                              </div><div className="mb-5">
                                <label
                                  htmlFor="email"
                                  className="mb-2 block text-base font-medium text-[#07074D] dark:text-gray-300"
                                >
                                  Item:
                                </label>
                                <input
                                  type="text"
                                  name="email"
                                  id="email"
                                  placeholder="Item name"
                                  className="w-full rounded-md border border-[#e0e0e0] bg-white py-2 px-6 text-base font-medium text-gray-700 outline-none focus:border-orange-500 focus:shadow-md dark:bg-gray-700 dark:text-gray-300"
                                />
                              </div>
                              <div className="mb-6 pt-4">
                                <label className="mb-5 block text-xl font-semibold text-[#07074D] dark:text-gray-300">
                                  Upload Image
                                </label>

                                <div className="mb-8">
                                  <input
                                    type="file"
                                    name="file"
                                    id="file"
                                    className="sr-only"
                                  />
                                  <label
                                    htmlFor="file"
                                    className="relative flex min-h-[200px] items-center justify-center rounded-md border border-dashed border-[#e0e0e0] p-12 text-center"
                                  >
                                    <div>
                {/*                       <span className="mb-2 block text-xl font-semibold text-[#07074D] dark:text-gray-300">
                                        Drop files here
                                      </span> */}
                                      <span className="mb-2 block text-base font-medium text-gray-700 dark:text-gray-300">
                                        Or
                                      </span>
                                      <span className="inline-flex rounded border border-[#e0e0e0] py-2 px-7 text-base font-medium text-[#07074D] dark:text-gray-300">
                                        Browse
                                      </span>
                                    </div>
                                  </label>
                                </div>
                              </div>
                              <div>

                       
                                <button
                                onClick={()=> setOpen(false)}
                                  type="button"
                                  className={
                                    "bg-red-50 mx-1 px-4 py-2  float-right rounded-md text-red-500 hover:bg-red-200 border border-transparent focus:outline-none focus:ring-2 focus:ring-red-500 focus:border-transparent dark:text-red-100 dark:bg-red-600"
                                  }
                                  // {...props}
                                >
                                  <XCircleIcon className="inline w-6 h-6 mx-2" />
                                  Cancel
                                  {/* {children} */}
                                </button>
                              </div>
                            </form>
                          </div>
                        </div>

                        {/* <div className="h-full border-2 border-dashed border-gray-200" aria-hidden="true" /> */}
                      </div>
                      {/* {/* /End replace */}
                    </div>
                  </div>
                </Dialog.Panel>
              </Transition.Child>
            </div>
          </div>
        </div>
      </Dialog>
    </Transition.Root>
  );
}
